import { mutatorAction } from 'satcheljs';
import getRewardsPointsStore from '../store/rewardsPointsStore';

export const setRewardsPanelOpenedMutator: (accountKey: string) => void = mutatorAction(
    'SET_REWARDS_PANEL_OPENED',
    (accountKey: string): void => {
        const store = getRewardsPointsStore();
        store.panelOpenedByAccount = { ...store.panelOpenedByAccount, [accountKey]: true };
    }
);
